import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularCertificate: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_certificate"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="certificate icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M18.0006 9.9997C20.2101 9.9997 22.0013 11.7909 22.0013 14.0003C22.0013 15.0154 21.6232 15.9422 21.0003 16.6475L21.0002 21.2484C21.0002 21.8192 20.3957 22.1678 19.9101 21.9173L19.8206 21.8632L18.0003 20.5909L16.1806 21.8632C15.7127 22.1901 15.0807 21.8943 15.008 21.3527L15.0011 21.2484L15.0001 16.6465C14.3777 15.9413 14 15.0149 14 14.0003C14 11.7909 15.7911 9.9997 18.0006 9.9997ZM19.4994 17.7108C19.0365 17.8979 18.5306 18.001 18.0006 18.001C17.4699 18.001 16.9633 17.8976 16.4999 17.71L16.5003 19.8089L17.5711 19.0618C17.7968 18.9041 18.0878 18.8844 18.3298 19.0027L18.4302 19.0618L19.4993 19.8089L19.4994 17.7108ZM19.25 3.00391C20.7125 3.00391 21.9084 4.14561 21.995 5.58638L22 5.75391L22.0014 10.9998C21.5971 10.4616 21.0867 10.0076 20.5013 9.66887L20.5 5.75391C20.5 5.1067 20.0081 4.57437 19.3778 4.51036L19.25 4.50391H4.75C4.10279 4.50391 3.57047 4.99578 3.50645 5.6261L3.5 5.75391V15.2539C3.5 15.9011 3.99187 16.4334 4.62219 16.4975L4.75 16.5039L13.6716 16.5051L13.7955 16.7076L13.9291 16.9043L14 16.9977L13.999 18.0039H4.75C3.28747 18.0039 2.0916 16.8622 2.00502 15.4214L2 15.2539V5.75391C2 4.29137 3.1417 3.0955 4.58248 3.00892L4.75 3.00391H19.25ZM18.0006 11.4997C16.6196 11.4997 15.5 12.6193 15.5 14.0003C15.5 15.3814 16.6196 16.501 18.0006 16.501C19.3817 16.501 20.5013 15.3814 20.5013 14.0003C20.5013 12.6193 19.3817 11.4997 18.0006 11.4997ZM11.25 12.4997C11.6642 12.4997 12 12.8355 12 13.2497C12 13.6294 11.7178 13.9432 11.3518 13.9929L11.25 13.9997H6.75C6.33579 13.9997 6 13.6639 6 13.2497C6 12.87 6.28215 12.5562 6.64823 12.5065L6.75 12.4997H11.25ZM17.25 6.9997C17.6642 6.9997 18 7.33549 18 7.7497C18 8.1294 17.7178 8.44319 17.3518 8.49286L17.25 8.4997H6.75C6.33579 8.4997 6 8.16392 6 7.7497C6 7.37001 6.28215 7.05621 6.64823 7.00655L6.75 6.9997H17.25Z" />
      </svg>
    </span>
  );
};

export { RegularCertificate };
